import { fmtSEK } from "../revenue/format";

const fmtPct = (v) => (v == null ? "N/A" : `${v.toFixed(1)}%`);

export default function PnlSummary({ fy, ytd, targets }) {
  const decTarget = (key) =>
    targets?.[key]?.["12"] ?? Object.values(targets?.[key] ?? {}).find((v) => v != null) ?? null;
  const cards = [
    { label: "Expected Sales (FY)", value: `${fmtSEK(fy.total_sales)} kr`, testId: "pnl-summary-sales" },
    { label: "Gross Profit (FY)", value: `${fmtSEK(fy.gross_profit)} kr`, testId: "pnl-summary-gp" },
    { label: "Gross Margin (FY)", value: fmtPct(fy.gross_margin), target: decTarget("gross_margin"), testId: "pnl-summary-gm" },
    { label: "Profit Before Tax (FY)", value: `${fmtSEK(fy.pbt)} kr`, strong: true, testId: "pnl-summary-pbt" },
    { label: "Net Margin (FY)", value: fmtPct(fy.net_margin), target: decTarget("net_margin"), testId: "pnl-summary-nm" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3 mb-4" data-testid="pnl-summary">
      {cards.map((c) => (
        <div
          key={c.label}
          className={`rounded-lg border p-3 ${c.strong ? "bg-[#0052CC] border-[#0052CC]" : "bg-white border-slate-200"}`}
          data-testid={c.testId}
        >
          <div className={`text-[11px] font-semibold uppercase tracking-wider ${c.strong ? "text-blue-100" : "text-slate-500"}`}>
            {c.label}
          </div>
          <div className={`text-lg font-bold mt-0.5 ${c.strong ? "text-white" : "text-slate-900"}`}>{c.value}</div>
          {c.target != null && (
            <div className={`text-[11px] mt-0.5 ${c.strong ? "text-blue-100" : "text-slate-400"}`} data-testid={`${c.testId}-target`}>
              Target {c.target}%
            </div>
          )}
          {c.target === null && (c.label.includes("Margin")) && (
            <div className="text-[11px] mt-0.5 text-slate-400">No target set</div>
          )}
        </div>
      ))}
    </div>
  );
}
